import {Box} from '@mui/material';
import HeaderBackoffice from './HeaderBackoffice';

export default props => {
    return (
        <>
            <HeaderBackoffice />
            <Box flexGrow={1}>{props.children}</Box>
        </>
    );
};
